import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const getJvBusinesses = createAsyncThunk(
    "jvReports/getJvBusinesses",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get("/api/admin/jvreports/businesses");
            return response.response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const getJvDealsByBusiness = createAsyncThunk(
    "jvReports/getJvDealsByBusiness",
    async (businessId, { rejectWithValue }) => {
        try {
            const response = await axios.get("/api/admin/jvreports/deals", {
                params: { businessId },
            });
            return response.response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const getJvInvestorsByDeal = createAsyncThunk(
    "jvReports/getJvInvestorsByDeal",
    async ({ dealId, businessId }, { rejectWithValue }) => {
        try {
            const response = await axios.get("/api/admin/jvreports/investors", {
                params: { dealId, businessId },
            });
            return response.response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const uploadJvReport = createAsyncThunk(
    "jvReports/uploadJvReport",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await axios.post("/api/admin/jvreports/upload", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const getJvReports = createAsyncThunk(
    "jvReports/getJvReports",
    async (params = {}, { rejectWithValue }) => {
        try {
            const response = await axios.get("/api/admin/jvreports", { params });
            return response.response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

const initialState = {
    businesses: [],
    deals: [],
    investors: [],
    reports: [],
    businessesLoading: false,
    dealsLoading: false,
    investorsLoading: false,
    uploadLoading: false,
    reportsLoading: false,
    error: null,
};

export const JvReportsSlice = createSlice({
    name: "jvReports",
    initialState,
    reducers: {
        clearDeals(state) {
            state.deals = [];
            state.investors = [];
            state.reports = [];
        },
        clearInvestors(state) {
            state.investors = [];
            state.reports = [];
        },
        clearReports(state) {
            state.reports = [];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getJvBusinesses.pending, (state) => {
                state.businessesLoading = true;
                state.error = null;
            })
            .addCase(getJvBusinesses.fulfilled, (state, action) => {
                state.businessesLoading = false;
                state.businesses = action.payload || [];
            })
            .addCase(getJvBusinesses.rejected, (state, action) => {
                state.businessesLoading = false;
                state.error = action.payload;
            })
            .addCase(getJvDealsByBusiness.pending, (state) => {
                state.dealsLoading = true;
                state.error = null;
            })
            .addCase(getJvDealsByBusiness.fulfilled, (state, action) => {
                state.dealsLoading = false;
                state.deals = action.payload || [];
            })
            .addCase(getJvDealsByBusiness.rejected, (state, action) => {
                state.dealsLoading = false;
                state.error = action.payload;
            })
            .addCase(getJvInvestorsByDeal.pending, (state) => {
                state.investorsLoading = true;
                state.error = null;
            })
            .addCase(getJvInvestorsByDeal.fulfilled, (state, action) => {
                state.investorsLoading = false;
                state.investors = action.payload || [];
            })
            .addCase(getJvInvestorsByDeal.rejected, (state, action) => {
                state.investorsLoading = false;
                state.error = action.payload;
            })
            .addCase(uploadJvReport.pending, (state) => {
                state.uploadLoading = true;
                state.error = null;
            })
            .addCase(uploadJvReport.fulfilled, (state) => {
                state.uploadLoading = false;
            })
            .addCase(uploadJvReport.rejected, (state, action) => {
                state.uploadLoading = false;
                state.error = action.payload;
            })
            .addCase(getJvReports.pending, (state) => {
                state.reportsLoading = true;
                state.error = null;
            })
            .addCase(getJvReports.fulfilled, (state, action) => {
                state.reportsLoading = false;
                state.reports = action.payload || [];
            })
            .addCase(getJvReports.rejected, (state, action) => {
                state.reportsLoading = false;
                state.error = action.payload;
            });
    },
});

export const { clearDeals, clearInvestors, clearReports } = JvReportsSlice.actions;
export default JvReportsSlice.reducer;
